import { Motion, spring } from 'react-motion';

import { Component, React } from '../../react';

import cx from './style.less';

const legacyIntervalTimeout = 100;
const markerBaseWidth = 100;
const markerMotion = { stiffness: 200, precision: 0.1 };

function getElementOffset(element: HTMLElement) {
  const s = element.getBoundingClientRect();
  const c = (element.parentNode as Element).getBoundingClientRect();
  const top = s.top - c.top;
  const left = s.left - c.left;
  return {
    h: element.offsetHeight,
    w: element.offsetWidth,
    x: left,
    y: top,
  };
}

export interface IElementMarkerProps {
  track: HTMLElement;
}
export class ElementMarker extends Component<IElementMarkerProps, any> {
  public state = {
    box: null as { x: number; y: number; w: number; h: number; },
    force: false,
    track: null as HTMLElement,
  };

  private _animationFrame = 'requestAnimationFrame' in window;
  private _timer: any;

  public componentDidMount() {
    if (this._animationFrame) {
      window.cancelAnimationFrame(this._timer);
      this._timer = window.requestAnimationFrame(this.update);
    } else {
      this._timer = setInterval(this.update, legacyIntervalTimeout);
      setInterval(this.update, 0);
    }
  }
  public componentWillUnmount() {
    if (this._animationFrame) {
      window.cancelAnimationFrame(this._timer);
    } else {
      clearInterval(this._timer);
    }
  }

  public componentDidUpdate() {
    if (this.props.track && this.state.box && this.state.force) {
      process.nextTick(() => this.setState({ force: false }));
    }
  }

  public render() {
    if (!this.props.track || !this.state.box) {
      return null;
    }

    const { force, box } = this.state;
    const { x, y, w, h } = box;

    const defaultStyle = {
      opacity: 1,
      w,
      x,
      y: y + h,
    };

    const targetStyle = {
      w: force ? w : spring(w, markerMotion),
      x: force ? x : spring(x, markerMotion),
      y: force ? y + h : spring(y + h, markerMotion),
    };

    return (
      <Motion defaultStyle={defaultStyle} style={targetStyle}>
        {(style: any) => (
          <div
            className={cx(`marker`)}
            style={{
              left: 0,
              position: 'absolute',
              top: 0,
              transform: `translate(${style.x}px, ${style.y}px) scaleX(${style.w / markerBaseWidth})`,
              transformOrigin: '0% 0%',
              width: '100px',
            }} />
        )}
      </Motion>
    );
  }

  private update = () => {
    if (this._animationFrame) {
      this._timer = window.requestAnimationFrame(this.update);
    }

    if (!this.props.track) {
      // Nothing to track.
      return this.setState({ track: null, force: true });
    }

    const box = getElementOffset(this.props.track);
    if (box.w * box.h === 0) {
      // Box invisible.
      return this.setState({ track: null, force: true });
    }

    if (!this.state.box
      || box.h !== this.state.box.h
      || box.w !== this.state.box.w
      || box.x !== this.state.box.x
      || box.y !== this.state.box.y) {
      // Position changed, update.
      this.setState({ box, track: this.props.track, force: this.state.force });
    }
  }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/shared/elementMarker/index.tsx